import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from './../actions';
import { User } from '../../users/models/user';
import { Role } from 'src/app/shared/models/role';

export const loginFeatureKey = 'auth';

export interface State {
  loading: boolean;
  loaded: boolean;
  isAuthentiate: boolean;
  accesToken: string;
  user: User;
  userLoading: boolean;
  userLoaded: boolean;
  currentRole: Role;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  isAuthentiate: false,
  accesToken: null,
  user: null,
  userLoading: false,
  userLoaded: false,
  currentRole: {
    code: null,
    shortName: null
  }
};

const loginReducer = createReducer(
  initialState,

  on(fromActions.login,
    state => ({ ...state, loading: true })
  ),

  on(fromActions.loginSuccess,
    (state, { access_token }) => ({
      ...state, loading: false, loaded: true, isAuthentiate: true, accesToken: access_token
    })),

  on(fromActions.logout,
    state => ({ ...initialState })
  ),

  on(
    fromActions.findUser,
    state => ({ ...state, userLoading: true, userLoaded: false })
  ),

  on(
    fromActions.findUserSuccess,
    (state, { user }) => ({ ...state, user, userLoading: false, userLoaded: true })
  ),

  on(fromActions.setCurrentRole,
    (state, { role }) => ({ ...state, currentRole: role })
  ),
);

export function reducer(state: State | undefined, action: Action) {
  return loginReducer(state, action);
}
